export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11374.30a40a80.jpg";